export default __webpack_public_path__ + "static/media/919.16fc2bef.gif";